// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"42c94a59","144":"4961ed75","623":"b0cde9d0","700":"2f30c581","702":"38ae6ea8","787":"1622b7c0","789":"bffda142","812":"02411940"}[chunkId] + ".chunk.js";
};